import { useEffect, useState } from "react";
import { toast } from "react-toastify"; // Import toast for warning messages
import ModalComp from "themes/elements/Modal";
import TextAreaComp from "themes/elements/TextArea";
import ModalFooter from "../modalFooter";

function RejectArticle({
  setIsReject,
  isReject,
  handleRejectCounsilor,
  isChangeLoading,
}) {
  const [reason, setReson] = useState("");

  const handleDelete = () => {
    // Validate if reason is provided
    if (!reason || reason.trim() === "") {
      toast.warn("Please enter a reason for rejecting this article");
      return; // Don't proceed with rejection if reason is empty
    }
    handleRejectCounsilor(reason); // Proceed with rejection if reason is valid
  };

  useEffect(() => {
    setReson(""); // Reset reason state on modal open
  }, [isReject]); // Re-run when modal is opened

  return (
    <ModalComp
      title="Reject this article ?"
      footer={
        <ModalFooter
          handlePrimaryBtn={() => setIsReject(false)}
          primaryBtnVariant="secondary"
          primaryBtnText="Cancel"
          secondaryBtnLoading={isChangeLoading}
          handleSecondaryBtn={handleDelete}
          secondaryBtnvariant="primary"
          secondaryBtnText="Submit"
        />
      }
      open={isReject}
      setOpen={(Value) => setIsReject(Value)}
    >
      <TextAreaComp
        maxValue={200}
        layoutClass="w-full"
        value={reason}
        onChange={(e) => setReson(e.target.value)}
        placeholder="Enter a clear and concise reason for rejecting this article..."
        label="Reason for Rejection"
      />
    </ModalComp>
  );
}

export default RejectArticle;
